function updateHeaderTransparency() {
  const header = document.querySelector('header');
  const firstSection = document.getElementById('MainContent')?.firstElementChild;
  const headerMainWrapper = document.querySelector('[header-main-wrapper]');

  if (!header || !firstSection || !headerMainWrapper) return;

  const topSpacer = getComputedStyle(firstSection).getPropertyValue('--topSpacer');
  const allowsTransparency = Boolean(firstSection.querySelector('[allow-header-transparent]'));

  header.classList.toggle('header-transparent', allowsTransparency);
  header.classList.toggle('section-spacing', allowsTransparency);
  headerMainWrapper.classList.toggle('section-spacing', !allowsTransparency);

  if (allowsTransparency) {
    document.body.style.setProperty('--headerMargin', topSpacer || '0px');
  } else {
    document.body.style.removeProperty('--headerMargin');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', updateHeaderTransparency, { once: true });
} else {
  updateHeaderTransparency();
}

document.addEventListener('shopify:section:load', updateHeaderTransparency);
